// extracted by mini-css-extract-plugin
export default {"footer":"footerCss_footer__eJYqA","owner":"footerCss_owner__4qu11"};